import { checkAccessToken } from "actions/authActions";
import { XSRF_COOKIE_NAME } from "api-v2";
import ky from "ky";
import { getCookie, removeAllCookie } from "utils/cookiesHelper";
import { showToast } from "utils/helpers";

const path = window.location.pathname;
const notLoggedinPath = [
	"/login",
	"/two-factor",
	"/two-factor-setup",
	"/member/login",
	"/guest/login",
	"/guest/signup",
].includes(path);

export default ky.extend({
	prefixUrl: process.env.REACT_APP_API_URL,
	timeout: 60000,
	credentials: "include",
	hooks: {
		beforeRequest: [
			(request) => {
				// Example: add XSRF token header from cookie or local storage
				const xsrfToken = getCookie(XSRF_COOKIE_NAME);
				if (xsrfToken) {
					request.headers.set("X-XSRF-TOKEN", xsrfToken);
				}

				// auto-inject _token for FormData
				if (request?.options?.body instanceof FormData) {
					request.options.body.append("_token", xsrfToken);
				}
			},
		],
		afterResponse: [
			async (request, options, response) => {
				// Mirror axios x-session-expires-at behavior
				const expiresAtHeader = response.headers.get("x-session-expires-at");
				if (expiresAtHeader) {
					const expiresAt = Number(expiresAtHeader) * 1000;
					window.__PROCURACON_SESSION_HOOK_UPDATE__?.(expiresAt);
				}

				if (!response.ok) {
					const error = await response.json();
					switch (response.status) {
						case 404:
							showToast(error?.message, "Error");
							break;
						case 401:
							if (!notLoggedinPath) {
								await checkAccessToken().then((status) => {
									if (!status) {
										localStorage.clear();
										removeAllCookie();
										window.location.href = "/login";
									}
								});
							}
							break;
						default:
							return error;
					}
				}
			},
		],
	},
});

const Clientweb = ky.extend({
	hooks: {
		credentials: "include",
		afterResponse: [
			async (request, options, response) => {
				if (!response.ok) {
					const error = await response.json();
					switch (error?.status) {
						case 404:
							showToast(error?.error, "Error");
							break;
						case 401:
							await checkAccessToken().then((status) => {
								if (!status) {
									removeAllCookie();
									localStorage.clear();
									window.location.href = "/login";
								}
							});
							break;
						default:
							return error;
					}
				}
			},
		],
	},
	prefixUrl: process.env.REACT_APP_API_URL,
});

export { Clientweb };
